// eslint-disable-next-line import/prefer-default-export
export const PHONE_NUMBERS = {
  CUSTOMER_SERVICE: '1-888-836-3939',
  LONG_DISTANCE: '1-423-641-0764',
  LONG_DISTANCE_V2: '1-888-303-6927',
  MODIFY_SERVICE: '1-877-381-4018',
  PARTNERSHIPS: '1-423-521-1485',
};
